<template>
  <div class="program-cate flex" v-if="cateList && cateList.length>0">
      <div v-for="(item ,index) in cateList" :key="index" class="program-cate-item flex-bd flex" :class="{'active': curIndex == index }" @mouseenter="mouseChange(index,item.id)" @mouseleave="changeOut" @click="clickChange(item.id)">
        <span class="iconfont" :class="item.icon"></span>
        <div class="item-txt">
          <p v-text="item.showname"></p>
          <em v-text="item.eName" :class="{'smallfont':item.eName.length >12}"></em>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'subCates',
  props: {
    curIndex: Number,
    cateList: Array,
  },
  data(){
    return{
    }
  },
  methods:{
    //鼠标滑过
    mouseChange(index,id){
      if(index==this.curIndex){
        return;
      };
      this.$emit("mouseChange",{
        id:id,
        index:index
      })
    },
    changeOut(){
      // console.log("滑出")
    },

    // 点击切换
    clickChange(id){
      this.$emit("clickChange",{
        id:id
      })
    }

  }
}
</script>

<style scoped>
</style>